<script setup lang="ts">
import './assets/style.scss'

defineProps({
  type: {
    type: String,
    default: 'keyboard_arrow_down',
  },
  icon: {
    type: String,
    default: '',
  },
  bold: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <span class="material-symbols-rounded v-icon" :class="{ 'v-icon_bold': bold }">
    {{ icon || type }}
  </span>
</template>
